import styled from 'styled-components';

const FeeBreakdownInfoModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export { FeeBreakdownInfoModalWrapper, ItemWrapper };
